export class FormAutoFiller {
    constructor(websocket) {
        this.ws = websocket;
        this.setupMessageHandler();
    }

    setupMessageHandler() {
        this.ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.type === 'form_data') {
                this.handleFormData(data);
            }
        };
    }
}

export default FormAutoFiller;